// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ed6e403d","995":"d6757697"}[chunkId] + ".chunk.js";
};